import React, { useState } from "react";
import { useFbutton } from "./hooks/useFbutton";
import Select from "react-select";

const Fbutton = ({ type, value, disabled = false, onClick = () => {} }) => {
  switch (type) {
    case "error":
      return (
        <FButtonError value={value} disabled={disabled} onClick={onClick} />
      );
    default:
      return <FButton value={value} disabled={disabled} onClick={onClick} />;
  }
};

const FButton = ({ value = "sin titulo", disabled, onClick = () => {} }) => {
  return (
    <>
      <div className="border-0 w-full pt-4">
        <input
          type="button"
          value={value}
          disabled={disabled}
          className={`w-full font-medium py-[11px] text-[4vw] smm:text-[15px] rounded-[14px] ${
            disabled
              ? "bg-colorDisabled text-black"
              : "bg-primary text-white cursor-pointer"
          }`}
          onClick={onClick}
        />
      </div>
    </>
  );
};

const FButtonError = ({
  value = "sin titulo",
  disabled,
  onClick = () => {},
}) => {
  return (
    <>
      <div className="border-0 w-full pt-4">
        <input
          type="button"
          value={value}
          disabled={disabled}
          className={`w-full font-medium py-[11px] text-[4vw] smm:text-[15px] rounded-[14px] ${
            disabled
              ? "bg-colorDisabled text-black"
              : "bg-colorError text-white cursor-pointer"
          }`}
          onClick={onClick}
        />
      </div>
    </>
  );
};

export default Fbutton;
